import http from '@/utils/http'

export default {
  url: 'sms/sms/v1',
  getSms(data, phone) {
    return http.post(`${this.url}/send?phone=${phone}`, data)
  }
}
